export interface JobBaseArtifactWithoutDefinitionParams {
  artifactId: string
  description?: string
  name?: string
}

export abstract class JobBaseArtifactWithoutDefinition {
  public artifactId: string
  public description?: string
  public name?: string

  protected constructor (params: JobBaseArtifactWithoutDefinitionParams) {
    this.artifactId = params.artifactId
    this.description = params.description
    this.name = params.name
  }
}

export interface JobBaseArtifactParams extends JobBaseArtifactWithoutDefinitionParams {
  definitionId: string
}

export abstract class JobBaseArtifact extends JobBaseArtifactWithoutDefinition {
  public definitionId: string

  protected constructor (params: JobBaseArtifactParams) {
    super(params)
    this.definitionId = params.definitionId
  }

  public get key (): string {
    return this.artifactId
  }
}
